import { getEnv } from '~/utils/env';

export function getSegmentWriteKey(): string {
  return getEnv('NEXT_PUBLIC_SEGMENT_IO_KEY');
}
